import { REQUEST_STALE_TIME_IN_MS as staleTime } from '@/constants';
import useListService from '@/data/hook/useListService';
import { flashcardActivityProgressQueries } from '@/data/query-keys/flashcardActivityProgressQueryKey';
import { FlashcardAnswerEnum } from '@/models/FlashcardActivityProgress';

const PAGE_SIZE = 1;

// TODO: replace this for backend api contract
export default function useUnitFlashcards(contentLessonId: number) {
  const total = useListService({
    ...flashcardActivityProgressQueries.list({
      lessonId: [contentLessonId],
      pageSize: PAGE_SIZE,
    }),
    staleTime,
  });
  const pending = useListService({
    ...flashcardActivityProgressQueries.list({
      lessonId: [contentLessonId],
      answer: [FlashcardAnswerEnum.REVIEW_AGAIN],
      pageSize: PAGE_SIZE,
    }),
    staleTime,
  });

  return {
    hasFlashcards: (total.meta?.pagination.count ?? 0) > 0,
    pendingCount: pending.meta?.pagination.count ?? 0,
    isLoading: total.isInitialLoading || pending.isInitialLoading,
  };
}
